import { Layout } from 'antd';
import _ from 'lodash';
import { useEffect, useState } from 'react';
import { Navigate, Route, Routes, useLocation } from 'react-router-dom';
import useAuth from '../hooks/useAuth.js';
import PrivateRoute from './PrivateRoute.js';
import PublicRoute from './PublicRoute.js';
import { getRoutes } from '../constants/Routes.js';
import { store } from '../redux/store.js';
import { setActiveUser } from '../redux/slices/messageSlice.js';

const { Content } = Layout;

const AppLayout = () => {
  const {
    token,
    user: { role },
  } = useAuth();
  const location = useLocation()

  const [publicRoutes] = useState(
    _.filter(Object.values(getRoutes(role)), (route) => !route?.permission)
  );
  const [privateRoutes] = useState(
    _.filter(Object.values(getRoutes(role)), (route) => route?.permission)
  );

  useEffect(() => {
    store.dispatch(setActiveUser(null));
  }, [location])

  return (
    <Layout style={{ height: '100dvh', overflow: 'auto' }}>
      <Layout className="site-layout">
        <Content>
          <Routes>
            {/* Public routes */}
            {!token && (
              <Route element={<PublicRoute />}>
                {publicRoutes.map((route) => (
                  <Route
                    key={route.name}
                    path={route.path}
                    element={route.element && <route.element />}
                  />
                ))}
                <Route path="*" element={<Navigate to="/" />} />
              </Route>
            )}

            {/* Private routes */}
            <Route element={<PrivateRoute />}>
              <Route path="/" element={<Navigate to="/chat" replace />} />
              {privateRoutes.map((route) => (
                <Route
                  key={route.name}
                  path={route.path}
                  element={route.element && <route.element />}
                />
              ))}
              <Route path="*" element={<Navigate to="/" />} />
            </Route>
          </Routes>
        </Content>
      </Layout>
    </Layout>
  );
};

export default AppLayout;
